import React from 'react';

interface InfoTooltipIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

/**
 * InfoTooltipIcon Component
 * 
 * A circular info icon with 'i' symbol used for tooltips and help indicators.
 * 
 * @component
 * @example
 * ```tsx
 * <InfoTooltipIcon size={16} color="#000" />
 * ```
 */
export const InfoTooltipIcon: React.FC<InfoTooltipIconProps> = ({ 
  size = 16, 
  color = '#000',
  ...props 
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    fill="none" 
    viewBox="0 0 16 16"
    {...props}
  >
    <path 
      fill={color} 
      d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m1.05 4.298c.52 0 .942-.361.942-.896s-.423-.896-.942-.896c-.52 0-.94.361-.94.896s.42.896.94.896m.183 5.627c0-.107.037-.385.016-.543l-.822.946c-.17.179-.383.303-.482.27a.2.2 0 0 1-.13-.23l1.37-4.328c.112-.549-.196-1.05-.849-1.114-.689 0-1.703.699-2.32 1.586 0 .106-.02.37.002.528l.82-.947c.17-.177.369-.302.468-.268a.2.2 0 0 1 .122.252l-1.357 4.307c-.157.504.14.998.86 1.11 1.06 0 1.686-.682 2.304-1.569z"
    />
  </svg>
);

export default InfoTooltipIcon;

